// GENERATED FILE - DO NOT EDIT.
// Source: backend/tests/snapshots/openapi_contract.json, via `npm run gen:api` (orval).
// Regenerate after the API contract changes; `npm run check:gen-api` fails when this is stale.
import * as zod from 'zod';

export const ProofMetric = zod.object({
  "after": zod.union([zod.string(),zod.null()]),
  "before": zod.union([zod.string(),zod.null()]),
  "case_id": zod.uuid(),
  "case_label": zod.string(),
  "label": zod.string(),
  "unit": zod.union([zod.string(),zod.null()]),
  "value": zod.union([zod.string(),zod.null()])
});

export type ProofMetric = zod.input<typeof ProofMetric>;
export type ProofMetricOutput = zod.output<typeof ProofMetric>;
